import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { TypeFilter } from "~/components/Filters/TypeFilter/TypeFilter";
import { useTypeFilterUpdate } from "~/components/Filters/TypeFilter/useTypeFilterUpdate";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { clearItemTypeFiltersAction } from "~/store/filters/actions";
import { hasItemTypesValuesSelector, selectedAssetFileKindFiltersSelector, selectedItemTypesFiltersSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleTypeFilter = /*#__PURE__*/ memo((param)=>{
    let { availableTypes, onApplyClick } = param;
    const { onTypeSelectedChange: onTypeSelectedChangeCallback, onAssetFileKindSelectedChange: onAssetFileKindSelectedChangeCallback } = useTypeFilterUpdate();
    const dispatch = useDispatch();
    const hasValues = useAirSelector(hasItemTypesValuesSelector);
    const selectedTypes = useSelector(selectedItemTypesFiltersSelector);
    const selectedAssetFileKinds = useSelector(selectedAssetFileKindFiltersSelector);
    const { searchImprovements } = useTemporaryFeatureFlags();
    const clearValues = useCallback(()=>{
        dispatch(clearItemTypeFiltersAction());
    }, [
        dispatch
    ]);
    const onTypeSelectedChange = useCallback((params)=>{
        onTypeSelectedChangeCallback(params);
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        onApplyClick,
        onTypeSelectedChangeCallback,
        searchImprovements
    ]);
    const onAssetFileKindSelectedChange = useCallback((params)=>{
        onAssetFileKindSelectedChangeCallback(params);
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        onApplyClick,
        onAssetFileKindSelectedChangeCallback,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "type",
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(TypeFilter, {
            availableTypes: availableTypes,
            selectedTypes: selectedTypes,
            selectedAssetFileKinds: selectedAssetFileKinds,
            onTypeSelectedChange: onTypeSelectedChange,
            onAssetFileKindSelectedChange: onAssetFileKindSelectedChange
        })
    });
});
SingleTypeFilter.displayName = "SingleTypeFilters";
